$('.answers__item__caption').on('click', function () {
    const $button = $(this);
    const $item = $(this).closest('.answers__item');
    const $content = $item.find('.answers__item__content');
    $('.answers__item__caption').not($button).removeClass('active');
    $('.answers__item__content').not($content).slideUp();
    $button.toggleClass('active');
    $content.slideToggle();
});